import React from "react";
import HelpAll from "../component/sections/help/All";
import StepByStepCreateCampaignBanner from "../component/sections/help/StepByStepCreateCampaignBanner";
import middleware from "./middlewares/middleware";

const routes = [
  {
    path: "/help",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <HelpAll />,
        "HelpAll"
      );
    },
    exact: true,
  },
  {
    path: "/help/step-by-step-create-campaign-banner",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <StepByStepCreateCampaignBanner />,
        "StepByStepCreateCampaignBanner"
      );
    },
    exact: true,
  },
];

export default routes;
